




















import { Vue, Component } from 'vue-property-decorator'
import { mapGetters, mapState } from 'vuex'
import { getVideoSpec } from '@/types/Tutoriel'

@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA']),
        ...mapState('auth', ['user', 'authUser'])
    }
})
export default class Test extends Vue {
    code_video = ''
    libelle_video = ''

    beforeMount () {
        this.code_video = getVideoSpec(this.$route.params.video_name).code
        this.libelle_video = getVideoSpec(this.$route.params.video_name).libelle
    }
}
